import axios from 'axios';
import { API_BASE_URL } from './config';

export const getAllECMLicenses = async () => {
    const response = await axios.get(`${API_BASE_URL}/ecm-license`);
    return response.data;
};

export const getECMLicense = async (id) => {
    const response = await axios.get(`${API_BASE_URL}/ecm-license/${id}`);
    return response.data;
};

export const createECMLicense = async (licenseData) => {
    const response = await axios.post(`${API_BASE_URL}/ecm-license`, licenseData);
    return response.data;
};

export const updateECMLicense = async (id, licenseData) => {
    const response = await axios.put(`${API_BASE_URL}/ecm-license/${id}`, licenseData);
    return response.data;
};

export const deleteECMLicense = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/ecm-license/${id}`);
    return response.data;
};